<template>
    <div>
        {{ fullName }}
    </div>
</template>

<script>
import { computed } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';

export default {
    setup() {
        const auth = useAuth0();

        const fullName = computed(() => {
            if (!auth.user.value) return '';
            return `${auth.user.value.given_name || ''} ${auth.user.value.family_name || ''}`.trim();
        });

        return {
            auth,
            fullName,
        };
    },
};
</script>
